import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { environment } from './../../environments/environment.prod';
import { LogService, AppContext } from './';

declare const AWS: any;
declare const apigClientFactory: any;
declare const AWSCognito: any;

@Injectable()
export class ApiService {
  client: any = null;
  userPool: any = null;
  poolData = {
    UserPoolId: environment.userPoolId,
    ClientId: environment.clientId,
    Paranoia: 7
  };

  cognitoParams = {
    IdentityPoolId: environment.identityPoolId
  };

  count: number = 0;

  constructor(private titleService: Title, private logger: LogService, private app: AppContext) {
    this.logger.log('api.service', 'constructor', environment);
  }

  initUserPool() {
    return new Promise((resolve, reject) => {
      try {
        AWS.config.region = environment.region;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials(this.cognitoParams);
        AWSCognito.config.region = environment.region;

        this.userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(this.poolData);

        let cognitoUser = this.userPool.getCurrentUser();
        if (cognitoUser !== null) {

          cognitoUser.getSession((err, session) => {

            if (session) {
              let loginToken: string = ``;

              AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityId: AWS.config.credentials.identityId,
                IdentityPoolId: environment.identityPoolId,
                Logins: {
                  [`cognito-idp.${environment.region}.amazonaws.com/${environment.userPoolId}`]: session.getIdToken().getJwtToken()
                }
              });

              AWSCognito.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityId: session.identityId,
                IdentityPoolId: environment.identityPoolId,
                Logins: {
                  [`cognito-idp.${environment.region}.amazonaws.com/${environment.userPoolId}`]: session.getIdToken().getJwtToken()
                }
              });
              this.app.setLogin(true);
              resolve();
            }
          });
        } else {
          AWSCognito.config.credentials = new AWS.CognitoIdentityCredentials(this.cognitoParams);
          AWSCognito.config.update({ accessKeyId: 'anything', secretAccessKey: 'anything' });
          resolve();
        }
      } catch (ex) {
        reject();
      }
    });
  }

  getCognitoId(): string {
    var cognitoidentity = new AWS.CognitoIdentity();
    return cognitoidentity.config.credentials.identityId;
  }

  getApiClient() {
    return new Promise((resolve, reject) => {
      // this.logger.log('api.service', 'getApiClient', 'in return promise of getApiClient');
      if (this.client !== null) {
        resolve(this.client);
      } else {
        this.generateApiClient().then(() => {
          // this.logger.log('api.service', 'getApiClient', this.client);
          resolve(this.client);
        });
      }
    });
  }

  generateApiClient() {
    return new Promise((resolve, reject) => {
      if (this.userPool === null) {
        this.initUserPool().then(() => {
          this.initClient().then(client => {
            resolve(client);
          });
        });
      } else {
        this.initClient().then(client => {
          resolve(client);
        });
      }
    });
  }

  initClient() {
    return new Promise((resolve, reject) => {
      this.initUser().then(() => {
        this.client = apigClientFactory.newClient({
          accessKey: AWS.config.credentials.accessKeyId,
          secretKey: AWS.config.credentials.secretAccessKey,
          sessionToken: AWS.config.credentials.sessionToken,
          region: environment.region
        });
        resolve(this.client);
      });
    });
  }

  initUser() {
    return new Promise((resolve, reject) => {
      AWS.config.credentials.get(() => {
        resolve();
      });
    });
  }

  handleError(err) {
    // Do not bind this. Unless they have the logger and context injected
    this.logger.log('api.service', 'handleError', err);
    try {
      if (err.status === 429) {
        if (this.app.accountType === '') {
          this.app.showMessage(err.data.message, 'Sorry, you have exceeded your search limit. Please try again later or register for free.');
        } else {
          this.app.showMessage(err.data.message, 'Sorry, you have exceeded your search limit. Please try again later or upgrade your plan.');
        }
      }
      if (err.status === 504) {
        let message = err.statusText || err.message;
        this.app.showMessage(message, 'An unexpected error has occurred. Please try again');
      }
      if (err.status === 0) {
        // Really status code 403
        // this.signOut();
        this.client = null;
        this.userPool = null;
        return 403;
      }
      return null;
    } catch (ex) {
      this.logger.log('api.service', 'handleError catch', 'err created an exception');
      return null;
    }
  }

  destroy() {
    localStorage.clear();

    let cognitoUser = this.userPool.getCurrentUser();
    if (cognitoUser !== null && cognitoUser !== undefined) {
      cognitoUser.signOut();
      cognitoUser.globalSignOut();
    }

    AWS.config.credentials.clearCachedId();
    this.client = null;
    this.userPool = null;
    let credentials = new AWS.CognitoIdentityCredentials(this.cognitoParams);
    AWS.config.credentials = credentials;
    AWS.config.credentials.get(() => {
      // check for credentials
    });

    AWS.config.credentials.refresh((error) => {
      this.getApiClient().then(client => {
        // console.log('destroy complete');
      });
    });
  }

  signOut() {
    this.client = null;
    localStorage.removeItem('password'); // just in case it is set

    let cognitoUser = this.userPool.getCurrentUser();
    if (cognitoUser !== null && cognitoUser !== undefined) {
      cognitoUser.signOut();

      AWS.config.credentials.clearCachedId();
      let credentials = new AWS.CognitoIdentityCredentials(this.cognitoParams);
      AWS.config.credentials = credentials;
      AWS.config.credentials.get(() => {
        // check for credentials
      });
      this.client = null;
      this.userPool = null;

      AWS.config.credentials.refresh((error) => {
        this.getApiClient().then(client => {
          this.app.setLogin(false);
        });
      });
    } else {
      // should never be reached
      this.client = null;
      this.userPool = null;
      this.getApiClient().then(client => {
        AWS.config.credentials.refresh((error) => {
          setTimeout(() => {
            this.app.setLogin(false);
          }, 500);
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/api.service.ts